import { Link, LinkProps } from "react-router-dom";
import { useStyles } from "./styles";

export interface IRouterLinkProps extends LinkProps {
  noUnderline?: boolean;
}

const RouterLink = ({ noUnderline, ...props }: IRouterLinkProps) => {
  const classes = useStyles({ noUnderline });

  return <Link {...props} className={classes.content} />;
};

export default RouterLink;
